import {getBackendErrorMessage} from "../../shared/utils/httpError";
export {extractListPayload} from "../../shared/utils/payload";

// Situações da assinatura (BBF-3), iguais ao CHECK da migration 0063 e ao app-licencas.
export const LICENCA_STATUS_OPTIONS = ['AGUARDANDO_CARTAO', 'TRIAL', 'ATIVA', 'EM_ATRASO', 'SOMENTE_CONSULTA', 'SUSPENSA', 'CANCELADA'];
// Em que a licença pode nascer pelo POST.
export const LICENCA_STATUS_DE_CRIACAO = ['ATIVA', 'TRIAL', 'AGUARDANDO_CARTAO'];
export const LICENCA_STATUS_LABELS = {
    AGUARDANDO_CARTAO: 'Aguardando cartão',
    TRIAL: 'Trial',
    ATIVA: 'Ativa',
    EM_ATRASO: 'Em atraso',
    SOMENTE_CONSULTA: 'Somente consulta',
    SUSPENSA: 'Suspensa',
    CANCELADA: 'Cancelada',
};
// Para onde cada situação pode ir: a tabela `licencas_situacao_transicoes` da 0063. O backend
// confere de novo e responde 409 fora dela; aqui serve para a tela só oferecer o que vale.
export const LICENCA_TRANSICOES = {
    AGUARDANDO_CARTAO: ['TRIAL', 'ATIVA', 'CANCELADA'],
    TRIAL: ['ATIVA', 'CANCELADA'],
    ATIVA: ['EM_ATRASO', 'SOMENTE_CONSULTA', 'SUSPENSA', 'CANCELADA'],
    EM_ATRASO: ['ATIVA', 'SOMENTE_CONSULTA', 'SUSPENSA', 'CANCELADA'],
    SOMENTE_CONSULTA: ['ATIVA', 'SUSPENSA', 'CANCELADA'],
    SUSPENSA: ['ATIVA', 'CANCELADA'],
    CANCELADA: ['ATIVA'],
};
// Tipos que o app-licencas aceita (VALID_TYPES).
export const LICENCA_TIPO_OPTIONS = ['PAGO', 'TRIAL', 'DEMO'];
export const LICENCA_TIPO_LABELS = {PAGO: 'Pago', TRIAL: 'Trial', DEMO: 'Demonstração'};

export const getStatusLabel = (status) => LICENCA_STATUS_LABELS[status] || status || '-';
export const getTipoLabel = (tipo) => LICENCA_TIPO_LABELS[tipo] || tipo || '-';
export const getTransicoes = (status) => LICENCA_TRANSICOES[status] || [];

export const formatDateBR = (value) => {
    if (!value) return '-';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleDateString('pt-BR');
};

export const formatMoney = (value) => {
    const amount = Number(value);
    if (Number.isNaN(amount)) return '-';
    return new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(amount);
};

export const getBackendMessage = (error, fallbackMessage) => getBackendErrorMessage(error, fallbackMessage);

export const normalizeLicencaRows = (items = []) => items.map((item) => ({
    ...item,
    validade_inicio_fmt: formatDateBR(item.validade_inicio),
    validade_fim_fmt: formatDateBR(item.validade_fim),
    data_proxima_cobranca_fmt: formatDateBR(item.data_proxima_cobranca),
    data_ultima_cobranca_fmt: formatDateBR(item.data_ultima_cobranca),
    data_bloqueio_previsto_fmt: formatDateBR(item.data_bloqueio_previsto),
}));

export const getStatusColor = (status) => {
    if (status === 'ATIVA') return 'success';
    if (status === 'TRIAL' || status === 'AGUARDANDO_CARTAO') return 'info';
    if (status === 'EM_ATRASO') return 'error';
    if (status === 'SUSPENSA' || status === 'SOMENTE_CONSULTA') return 'warning';
    return 'default';
};

export const getDiasRestantes = (dateString) => {
    if (!dateString) return null;
    const value = new Date(dateString).getTime();
    if (Number.isNaN(value)) return null;
    return Math.ceil((value - Date.now()) / (1000 * 60 * 60 * 24));
};
